$(document).ready(function() {
	$(".close").click(function(e) {
		$("#shippingModal").css('display', 'none');
		$('#billingModal').css('display', 'none');
		$("#body").toggleClass('modal-open');

		$('#shipping_address_form')[0].reset();
	});
	$(".bottom-close").click(function(e) {
		$("#shippingModal").css('display', 'none');
		$('#billingModal').css('display', 'none');
		$("#body").toggleClass('modal-open');

		$('#shipping_address_form')[0].reset();
	});

	$(window).click(function(event) {
		if (event.target['id'] == "shippingModal") {
			$("#shippingModal").css('display', "none");
			$("#body").toggleClass('modal-open');

			$('#shipping_address_form')[0].reset();
			$("#address_type").val('shipping');
		}
	});

});
$(document).on('click', '.edit-address', function (e) {
	$("#shippingModal").css('display', 'block');
	$("#body").toggleClass('modal-open');

	if($(this).data('number') == 0)
		$('.modal-title').text('Edit Default Shipping Address');
	else
		$('.modal-title').text('Edit Alt Shipping Address #' + $(this).data('number'));

	$("#shipping_address_form input[name='contact']").val($(this).data('contact'));
	$("#shipping_address_form select[name='country_id']").val($(this).data('country_id'));
	$("#shipping_address_form input[name='address_street_1']").val($(this).data('address_1'));
	$("#shipping_address_form input[name='address_street_2']").val($(this).data('address_2'));
	$("#shipping_address_form input[name='company_title']").val($(this).data('company_title'));
	$("#shipping_address_form select[name='state_id']").val($(this).data('state_id'));
	$("#shipping_address_form input[name='city']").val($(this).data('city'));
	$("#shipping_address_form input[name='zip']").val($(this).data('zip'));
	$("#shipping_address_form input[name='contact_id']").val($(this).data('contact_id'));
	$("#shipping_address_form input[name='company_address_id']").val($(this).data('company_address_id'));
	$("#shipping_address_form input[name='address_id']").val($(this).data('address_id'));
	$("#shipping_address_form input[name='number']").val($(this).data('number'));

	const options = $('.profile-state-select option');
	options.prop('style', 'display:none;');

	const countryId = $(this).data('country_id');
	const countryOptions = $(`.profile-state-select option[data-country="${countryId}"]`);
	countryOptions.prop('style', '');
});

$(document).on('click', '.add-address', function (e) {
	$("#shippingModal").css('display', 'block');
	$("#body").toggleClass('modal-open');

	$('.modal-title').text('Add Shipping Address');
});

$(document).on('click', '.edit-billing-address', function (e) {
	$("#billingModal").css('display', 'block');
	$("#body").toggleClass('modal-open');

	$("#billing_address_form input[name='contact']").val($(this).data('contact'));
	$("#billing_address_form select[name='country_id']").val($(this).data('country_id'));
	$("#billing_address_form input[name='address_street_1']").val($(this).data('address_1'));
	$("#billing_address_form input[name='address_street_2']").val($(this).data('address_2'));
	$("#billing_address_form input[name='company_title']").val($(this).data('company_title'));
	$("#billing_address_form select[name='state_id']").val($(this).data('state_id'));
	$("#billing_address_form input[name='city']").val($(this).data('city'));
	$("#billing_address_form input[name='zip']").val($(this).data('zip'));
	$("#billing_address_form input[name='contact_id']").val($(this).data('contact_id'));
	$("#billing_address_form input[name='company_address_id']").val($(this).data('company_address_id'));
	$("#billing_address_form input[name='address_id']").val($(this).data('address_id'));
	$("#billing_address_form input[name='number']").val($(this).data('number'));
});

;(function ($) {
    'use strict';
    $(document).ready(function () {
		$(document).on('click', function (e) {
			const container = $('.simple-modal-container');
			if (
				!container.hasClass('open')
				|| e.target.classList.contains('simple-modal-open')
			) {
				return;
			}

			const modal = $('.simple-modal-container .modal-contents');

			if (!modal.is(e.target) && modal.has(e.target).length === 0) {
				container.removeClass('open');
			}
		});

        $('.simple-modal-open').on('click', function (e) {
			$('.simple-modal-container').addClass('open');

			const iframe = $('.simple-modal-container iframe');
			if (iframe.length) {
				iframe[0].src = iframe[0].src + (iframe[0].src.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1';
			}
		});

		$('.simple-modal-close').on('click', function () {
			$('.simple-modal-container').removeClass('open');
		});
    });
})(jQuery, window, document);
